import React from 'react';

const DirectionSteps = (props) => {
	// destruction not working with current babel using assignment instead
	const walking = props.walkingSteps.WALKING;
	const driving = props.drivingSteps.DRIVING;

	return (
		<React.Fragment>
			{!!driving && !!driving.routes[0] && (
				<Step steps={driving.routes[0]} mode={'Driving'}/>
			)}
			{!!walking && !!walking.routes[0] && (
				<Step steps={walking.routes[0]} mode={'Walking'}/>
			)}
		</React.Fragment>
	);
};

const Step = (props) => {
	return (
		<div className="row justify-content-center DirectionModal-directionsolder pt-4">
			<div className="col-12 col-lg-11">
				<div className="row">
					{props.steps.legs.map((leg) => (
						<React.Fragment
							key={`leg_${leg.start_address}_${leg.end_address}`}
						>
							<div className="col-12 col-md-4">
								<div className="DirectionModal-destinationSummary">
									<div className="font-weight-bold">Your directions from:</div>
									{leg.start_address}
									<div className="font-weight-bold">{props.mode} To:</div>
									{leg.end_address}
								</div>
							</div>
							<div className="col-12 offset-lg-1 col-md-8 col-lg-7">
								{leg.steps.map((step, i) => (
									<div
										key={`leg_${step.encoded_lat_lngs}`}
									>
										<div className="DirectionModal-step">
											<span>{i + 1}</span>
											<span
												className="DirectionModal-step-text"
												dangerouslySetInnerHTML={{
													__html: step.instructions,
												}}
											/>
											<span>{step.distance.text}</span>
										</div>
									</div>
								))}
							</div>
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	);
};

export default DirectionSteps;
